import React, { Component } from 'react'
import filesize from 'filesize';
import ImageItem from './image-item';

class ImageGrid extends Component {

	constructor(props) {
		super(props);
		this.createImageItems = this.createImageItems.bind(this);
	}

	createImageItems() {
		const imgItems = this.props.images.map((image) => {
			return (
				<ImageItem onClick={this.props.onImageClick} key={image.uuid} id={image.uuid} url={image.cdnUrl} name={image.filename.split('/').pop()} bucket={image.bucket} size={filesize(image.filesize)}/>
			)
		});
		return imgItems
	}

	render() {
		const imgItems = this.createImageItems();
		return (
			<div className="columns is-multiline">
				{imgItems}
			</div>
		)
	}
}

export default ImageGrid


// WEBPACK FOOTER //
// ./src/components/image-grid.jsx